import api from '@/services/api/whatsNew'
import { useState } from 'react'
class WhatsNew {

	constructor(params) {
		this.status = params.status
		this.body = params.body
		this.emailRecipient = params.emailRecipient
	}
}

const useWhatsNew = () => {

	const [error, setError] = useState()
	const [visible, setVisible]= useState(false)
	async function fetch() {

		const [err, response] =  await api.getWhatsNew();
		setVisible(true)

		if(err){
			setError(err);
			setVisible(false)
		}

		return [err, response];
	}

	async function fetchLastesId(){
		const [err, response] = await api.getWhatsNewLastestId();
		setVisible(true)
		if(err){
			setError(err);
			setVisible(false)
		}
		return [err,response]

	}

	async function accept(payload) {

		const [err, response] = await api.updateUserWhatsNewId(payload);
		if (err) {
			return setError(err);
		}
		return [err, response]
	}



	return {
		error,
		fetch,
		accept,
		fetchLastesId,
		visible,
		setVisible
	}

}

export default useWhatsNew
